<template>
  <list-slider
    :data="cards"
    :enable-gtm-tracking="true"
    :product-list-name="'Enjoyment cards'"
    :config="{
      cardTemplate: 'enjoyment-slider-card',
      attrTemplate: 'card',
      allowedGhost: true
    }"
    :slider-config="{
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: 15,
      breakpoints: {
        1: {
          slidesPerView: 'auto',
          slidesPerGroup: 1
        }
      }
    }"
  />
</template>

<script>
export default {
  props: ['vouchers'],
  computed: {
    cards() {
      return this.vouchers
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.swiper-prev) {
  left: 0.8%;

  @screen lg {
    @apply -left-7;
  }
}
:deep(.swiper-next) {
  right: 0.8%;
}

:deep(.swiper-slide img:not(.NotScale)) {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

:deep(.swiper-slide) {
  width: 65% !important;

  @screen md {
    width: 28.5% !important;
  }

  @screen lg {
    width: 23.75% !important;
  }
}
</style>
